import React from "react";
import ReactDOM from "react-dom";

const getErrorMessage = (error) =>
  error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  "Download file failed. Please try again.";

export default function showDownloadErrorToast(error) {
  if (typeof document === "undefined") return;

  const container = document.createElement("div");
  document.body.appendChild(container);

  let isClosed = false;

  const handleClose = () => {
    if (isClosed) return;

    isClosed = true;
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  ReactDOM.render(
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 9999,
        minWidth: "300px",
        maxWidth: "420px",
        padding: "14px 18px",
        borderRadius: "8px",
        background: "#dc3545",
        color: "#fff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "15px",
      }}
    >
      <span>{getErrorMessage(error)}</span>

      <button
        type="button"
        onClick={handleClose}
        style={{
          border: "none",
          background: "transparent",
          color: "#fff",
          fontSize: "20px",
          cursor: "pointer",
          padding: 0,
        }}
      >
        ×
      </button>
    </div>,
    container,
  );

  setTimeout(() => {
    handleClose();
  }, 4000);
}